import clsx from 'clsx';
import React from 'react';

export const PropertyList = props => <div {...props} />;

const Title = props => (
  <div {...props} className="text-xl font-bold flex items-start mb-2" />
);

export const PropertyListItem = props => (
  <div
    {...props}
    className="grid grid-cols-12 py-2 border-b border-gray-100 gap-x-4"
  />
);

export const PropertyListItemLabel = props => (
  <div {...props} className="col-span-5 font-semibold break-all" />
);

export const PropertyListItemValue = ({ className, ...props }) => (
  <div {...props} className={clsx('col-span-7', className)} />
);

PropertyList.Title = Title;
PropertyList.Item = PropertyListItem;
PropertyList.ItemLabel = PropertyListItemLabel;
PropertyList.ItemValue = PropertyListItemValue;

export default PropertyList;
